/**
 * Descripción: Gestor de Autentificación
 *
 * @displayName authentication
 */

import httpService from '@/services/httpService';
import router from '@/router';

export const namespaced = true;

export const state = {
  user: null,
  alert: 'No authorizado',
  route: '/'
};

export const mutations = {
  SET_USER_DATA(state, userData) {
    localStorage.setItem('user', userData.replace('"', ''));
    state.user = userData;
  },

  LOGOUT(state, error) {
    localStorage.removeItem('user');
    location.reload();
    if (error == true) {
      localStorage.setItem('alert', state.alert);
    }
  },

  SETROUTE(state) {
    router.push(state.route);
  },

  CACHEROUTES(state, to) {
    state.route = to;
  }
};

export const actions = {
  login({ commit }, credentials) {
    httpService.post('/User/Authenticate', credentials).then(response => {
      if (response != undefined) {
        commit('SET_USER_DATA', response.data.value);
        commit('SETROUTE');
      }
    });
  },

  logout({ commit }, error) {
    commit('LOGOUT', error);
  },

  save_route({ commit }, to) {
    commit('CACHEROUTES', to);
  }
};
